import React from 'react'
import TabAddPkgCategories from './page-components/page-categories/TabAddPkgCategories'
import TabViewPkgCategories from './page-components/page-categories/TabViewPkgCategories'

import MasterPageTab from './page-essential/MasterPageTab'

const PackageCategories = () => {
    return (
        <MasterPageTab addBtn='Add package category' viewBtn='View package category' addTab={<TabAddPkgCategories />} viewTab={<TabViewPkgCategories />} pageHeading={"Package categories"} pageDescription='Add/view/modify package categories' icon={null} />
    )
}

export default PackageCategories